<template>
  <div class="items-panel">
    <ul class="download-list" role="list">
      <li v-for="(item, key) in items" :key="item.name" class="download-item">
        <div v-if="item.type == 'dir'" class="folder-display">
          <span class="icon-text-wrapper">
            <i class="fa-solid fa-folder" aria-hidden="true"></i>
            <span class="sr-only">Folder</span>
            <a
              :href="decodeURIComponent(item.path)"
              :aria-label="'Open folder ' + item.name"
            >
              {{ item.name }}
            </a>
          </span>
        </div>
        <div v-else class="file-display">
          <span class="icon-text-wrapper">
            <i class="fa-solid fa-file" aria-hidden="true"></i>
            <span class="sr-only">File</span>
            <a
              :href="'file?path=' + decodeURIComponent(item.path)"
              :aria-label="'View file ' + item.name"
              >{{ item.name }}</a
            >
          </span>
          <span class="item-metadata">{{ item.size }}</span>
          <span class="item-metadata">{{ item.lastModified }}</span>
          <span class="icon-text-wrapper">
            <a
              :href="
                'file?path=' +
                decodeURIComponent(item.path) +
                '&force_download=true'
              "
              :title="'Download file ' + item.name"
              :aria-label="'Download file ' + item.name"
            >
              <i class="fa-solid fa-download"></i>
            </a>
            <a
              href="#"
              @click.prevent="copyDownloadPath(item.path)"
              :title="'Copy download link for ' + item.name"
              :aria-label="'Copy download link for ' + item.name"
            >
              <i class="fa-solid fa-copy ml-2"></i>
            </a>
            <div
              v-if="shouldShowPremiumIcon(item.name)"
              class="star-container ml-2 mb-2"
              aria-hidden="true"
            >
              <img src="@/assets/diamond.svg" height="20px" alt="Diamond" />
            </div>
          </span>
        </div>
      </li>
    </ul>
    <div v-if="loaded && (!items || items.length == 0)">
      Cannot load directory content. Please try again later or contact
      <a href="mailto:curator@arabidopsis.org">curator@arabidopsis.org</a>
    </div>
  </div>
</template>

<script>
import { getDownloadLink } from "@/services/DownloadService";
import { listDirContent } from "@/services/DownloadService";

export default {
  name: "DownloadList",
  data() {
    return {
      items: [],
      loaded: false,
    };
  },
  mounted() {
    this.fetchItems();
  },
  watch: {
    // Reactively watch for route changes, including query params
    "$route.query.dir": {
      immediate: true,
      async handler(newDir, oldDir) {
        await this.fetchItems();
      },
    },
  },
  methods: {
    shouldShowPremiumIcon(fileName) {
      const ignoredFiles = ["README.txt", ".DS_Store"];
      const currentDir = this.$route.query.dir || "";
      return (
        currentDir.includes("Subscriber_Data_Releases") &&
        !ignoredFiles.includes(fileName)
      );
    },
    async fetchItems() {
      if (this.$route.query.dir) {
        const items = await listDirContent(this.$route.query.dir);
        if (!items || items.length == 0) {
          // do nothing
        } else {
          this.items = items;
        }
      }
      this.loaded = true;
    },
    getDownloadLink(filePath) {
      return getDownloadLink(filePath);
    },
    copyDownloadPath(filePath) {
      const downloadLink = getDownloadLink(decodeURIComponent(filePath));
      navigator.clipboard
        .writeText(downloadLink)
        .then(() => {
          // You could add a toast notification here if desired
          console.log("Download link copied to clipboard");
        })
        .catch((err) => {
          console.error("Failed to copy download link:", err);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.download-list {
  list-style: none;
  padding-left: 0;
}
.content-wrapper {
  .items-panel {
    .item-metadata {
      margin-left: 10px;
    }
    .margin-right {
      margin-right: 10px;
    }
    .file-display {
      display: flex;
    }
    .icon-text-wrapper {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      i {
        margin-right: 10px;
      }
      .fa-folder {
        padding-bottom: 10px;
      }
      .fa-file {
        padding-bottom: 3px;
      }
      .fa-download {
        margin-left: 10px;
      }
      .fa-copy {
        cursor: pointer;
      }
    }
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
